import { createFileRoute } from "@tanstack/react-router";

// Route metadata only. Component lives in `mapping.lazy.tsx`.
export const Route = createFileRoute("/app/sources/$sourceId/routes/$routeId/mapping")({});
